export const title = 'Average CTR';

CTR (Click Through Rate) is the notification open rate, calculated as `qtd_aberturas / qtd_notificacoes_recebidas`.

This metric represents the average CTR across all campaigns.

`qtd_aberturas` is the number of notifications received and opened by customers.

`qtd_notificacoes_recebidas` is the number of notifications received by customers.
